import React from 'react'
import { Icon } from '@mobi/component-library/Common/V2/Icon'
import { colors } from '@mobi/component-library/Theme/Common'
import type { FobBetReceiptResponse } from '@mobi/betslip/types'
import { doesClientSupportShare } from '@core/Areas/ShareBet/helpers/doesClientSupportShare'
import { openShareOutgoing } from '@core/Areas/ShareBet/ShareBetOutgoing/helpers/emitter'
import {
  QuickbetState,
  state$ as quickbetState$,
  QuickbetStateRecord,
} from '@core/Areas/Quickbet/driver'
import { observeImmutable } from '@core/Components/HOCs/observe'
import { ReceiptButtonStyled } from '@core/Areas/Quickbet/Components/Receipt/Components/Common/Receipt.styles'

type Props = { receipt: FobBetReceiptResponse }

export const ShareButtonMulti: React.FC<Props> = ({ receipt }) => {
  if (!doesClientSupportShare()) return null

  return <ShareButtonComponent receipt={receipt} />
}

// ===============
// Local Component
// ===============

const ShareButtonComponent = observeImmutable<QuickbetStateRecord, Props>(
  quickbetState$,
  ({ record: quickbet, receipt }) => {
    const quickbetState = quickbet.toJS() as QuickbetState

    const { selectionMultiLegs } = quickbetState

    if (!selectionMultiLegs) return null

    const handleShareBetClick = () => {
      openShareOutgoing({
        contextType: 'quickbet',
        betSource: quickbetState.betSource,
        share: {
          items: selectionMultiLegs,
          ticketSequence: receipt.ticketNumber,
          multiReceipt: receipt,
        },
      })
    }

    return (
      <ReceiptButtonStyled
        onClick={handleShareBetClick}
        color='secondary'
        type='button'
        role='button'
      >
        <Icon name='LineShare02' color={colors.black} /> Share My Bet
      </ReceiptButtonStyled>
    )
  }
)
